module.exports = __webpack_public_path__ + "static/media/2023-02-09-slider-4.2a4ce803.jpg";